import {GLOSSARY_HASH_ALIAS} from 'app/components/glossary/constant';
import {ShouldSkipLazyLoadFn} from 'app/interface';
import {parseHashUrl} from 'app/utils/urlStateElements/parseHashUrl';

export const shouldSkipLazyLoad: ShouldSkipLazyLoadFn = () => {
    const urlState = parseHashUrl(window.location.hash.substring(1));
    return urlState[GLOSSARY_HASH_ALIAS] ? 'LOAD_EAGER' : 'LOAD_LAZY';
};
